<template>
  <div id="app">
    <top></top>
    <router-view :key="$route.fullPath"/>
    <foot></foot>
  </div>
</template>

<script>
import './assets/css/com.css';
import top from '@/components/top';
import foot from '@/components/foot';
export default {
  name: 'App',
  components:{
    top,
    foot
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue